import { useEffect } from 'react';
import { useServices } from '@/model';
import { installJournalCleanup } from './journal';
/** Mount once under Services so cold-start account removal also retires recovery receipts. */
export function ChatinfoRuntime(): null {
  const services = useServices();
  useEffect(() => { installJournalCleanup(services); }, [services]);
  return null;
}
